import { EventEmitter, Injectable, Output } from '@angular/core';
import { MessageCrudService } from '@evomatik/evk-common';
import { EstatusDesaparicionEnum } from '../enums/estatus-localizacion-enum';
import { EvkExpedienteModel } from '../models/evk-expediente.model';
import { ExpedienteUpdateEstatusService } from './expediente-update-estatus';
import { ExpedienteUpdateService } from './expediente-update.service';

@Injectable({
  providedIn: 'root'
})
export class ExpedienteEstatusService {


  @Output() notificacionEvent: EventEmitter<any> = new EventEmitter();

  constructor(public messageCrudService: MessageCrudService,
    public expedienteUpdateService: ExpedienteUpdateService,
    private expedienteUpdateEstatusService: ExpedienteUpdateEstatusService) { }




  /**
   * Funcion para notificar al area de analisis, cambio de estatus del expediente
   * @param expediente
   */
  notificarAnalisis(expediente: EvkExpedienteModel) {
    const confirmDialog = this.messageCrudService.openConfirmDialog({
        warn: '¿Está seguro de notificar al área de análisis? ',
        goonbtn: 'Notificar'
    });
    confirmDialog.componentInstance.resolveEvent.subscribe(() => {
        this.expedienteUpdateEstatusService.notificarAlAreaDeAnalisis(expediente.id).subscribe(() => {
            this.messageCrudService.snackbarMessage('Se ha notificado al área de análisis.');
            confirmDialog.close();
            this.notificacionEvent.emit(true);
        }, () => {
            this.messageCrudService.snackbarMessage('No se ha podido notificar al área de análisis.');
            confirmDialog.close();

        });
    });
}

/**
 * Funcion para notificar al area de busqueda, cambio de estatus del expediente
 * @param expediente
 */
notificarBusqueda(expediente: EvkExpedienteModel) {
    const confirmDialog = this.messageCrudService.openConfirmDialog({
        warn: '¿Está seguro de notificar al área de busqueda? ',
        goonbtn: 'Notificar'
    });
    confirmDialog.componentInstance.resolveEvent.subscribe(() => {
        this.expedienteUpdateEstatusService.notificarAlAreaDeBusqueda(expediente.id).subscribe(() => {
            this.messageCrudService.snackbarMessage('Se ha notificado al área de búsqueda.');
            confirmDialog.close();
            this.notificacionEvent.emit(true);
        }, () => {
            this.messageCrudService.snackbarMessage('No se ha podido notificar al área de búsqueda.');
            confirmDialog.close();

        });
    });
}

/**
 * Funcion para validar de acuerdo a la maquina de estados si puede mostrar la accion de notificar
 * hacia el area de analisis
 * @param expediente
 * @returns
 */
puedoNotificarHaciaAnalisis(expediente: EvkExpedienteModel): boolean{
    let result = false;
    if(expediente && expediente.estados){
        const estadoActivo = expediente.estados.find((e) => { return e.activo;});
        result =  estadoActivo && estadoActivo.estado.nombre == "Iniciado";
    }
    return result;
}

  /**
   * Funcion para validar de acuerdo a la maquina de estados si puede mostrar la accion de notificar
   * hacia el area de busqieda
   * @param expediente
   * @returns
   */
    puedoNotificarHaciaBusqueda(expediente: EvkExpedienteModel): boolean {
        let result = false;
        let result2 = false;
        if (expediente && expediente.estados) {
            const estadoActivo = expediente.estados.find((e) => { return e.activo; });
            result = estadoActivo && estadoActivo.estado.nombre == "Creado";
        }
        if (result && expediente.secciones && expediente.secciones.length > 0) {
            const seccionTarjeta = expediente.secciones.find(seccion => seccion.origen === 'tarjetaInformativa');
            if (seccionTarjeta !== undefined) {
                const propiedades = seccionTarjeta.propiedades;
                if (propiedades !== null && propiedades !== undefined) {
                    if (propiedades.informacion !== null && propiedades.informacion !== undefined && propiedades.informacion.length > 0) {
                        result2 = true;
                    }
                }
            }
        }
        return (result && result2);
    }

/**
 *
 * @param expediente Obtiene la descripcion de la leyenda del estatus
 * @returns
 */
validarEstatus (expediente: EvkExpedienteModel): string {
    if(expediente && expediente.secciones){
        let seccionInfoReporte = expediente.secciones.find((e) => {return e.origen === "circunstancias"});
        if(seccionInfoReporte && seccionInfoReporte.propiedades
            && seccionInfoReporte.propiedades.circunstanciaGen2
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.label){
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.LOCALIZADA_CON_VIDA){
                    return "LOCALIZADA";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.LOCALIZADA_SIN_VIDA){
                    return "LOCALIZADA";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.NO_LOCALIZADO){
                    return "NO LOCALIZADA";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.DESAPARECIDO){
                    return "DESAPARECIDA";
                }
        }
    }
    return "";
}

/**
 *
 * @param expediente Define el color de la etiqueta de acuerdo al estatus de localizacion del expediente
 * @returns
 */
validarEstatusColor (expediente: EvkExpedienteModel): string {
    if(expediente && expediente.secciones){
        let seccionInfoReporte = expediente.secciones.find((e) => {return e.origen === "circunstancias"});
        if(seccionInfoReporte && seccionInfoReporte.propiedades
            && seccionInfoReporte.propiedades.circunstanciaGen2
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.label){
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.LOCALIZADA_CON_VIDA){
                    return "1";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.LOCALIZADA_SIN_VIDA){
                    return "2";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.NO_LOCALIZADO){
                    return "3";
                }
                if( seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.value == EstatusDesaparicionEnum.DESAPARECIDO){
                    return "4";
                }
        }
    }
    return "";
}

/**
 * Valida si se debe de mostrar la etiqueta del estatus del expediente
 * @param expediente
 * @returns
 */
validarChipEstatus (expediente: EvkExpedienteModel): boolean {
    if(expediente && expediente.secciones){
        let seccionInfoReporte = expediente.secciones.find((e) => {return e.origen === "circunstancias"});
        if(seccionInfoReporte && seccionInfoReporte.propiedades
            && seccionInfoReporte.propiedades.circunstanciaGen2
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion
            && seccionInfoReporte.propiedades.circunstanciaGen2.estatusLocalizacion.label){
                return true;
        }
    }
    return false;
}




}
